<div class="row">
  <div class="col">
    <h5 class="title" [ngClass]="{'required': isRequired}">{{formTitle}}</h5>
    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null" [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="input col-md-12 col-sm-12 col-xs-12" [class.has-danger]="invalidForm">

      <select [id]="formItem.id" class="form-control"

              [name]="formItem.id"
              ngModel
              [(ngModel)]="formItem.value"
              #validationForm="ngModel"
              (change)="updateConditional()"
              [required]="isRequired">
        <option *ngFor="let option of radioOptions; let isLast = last" value="{{option.keydsi}}">{{option.labelField}}</option>
      </select>

        <div *ngIf="validationForm.invalid">
          <small *ngIf="validationForm.errors.required" class="incorrect-field">
            This field is required.
          </small>
        </div>
    </div>
  </div>
</div>
